import React, { PureComponent } from 'react';
import './index.scss';

export default class Header extends PureComponent {
  render() {
    const { topicLogo, topicTittle } = this.props;
    return (
      <header className="global-header">
        <div>
          <a
            href="http://lanxiongsports.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="http://imgcdn.lanxiongsports.com/upload/topic/lx_logo.png"
              alt="懒熊体育"
            />
          </a>
          {topicLogo && topicLogo !== '' ? (
            <img src={topicLogo} alt="" className="topic-logo" />
          ) : (
            <span>{topicTittle}</span>
          )}
        </div>
      </header>
    );
  }
}
